import React, { useState, useEffect } from "react";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import { api } from "../../../utils/Api";
import { useParams } from "react-router-dom";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();

const initial_value = {
  service_id: "",
  message: "",
  free: true,
  gst: false,
  amount: "",
  gst_amount: "",
  total_amount: "",
  task: [],
};

export default function ModalCreateRework(props: any) {
  const [save_data, SetSaveData] = useState(initial_value);
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [is_open, SetIsOpen] = useState(false);
  const [id_value, SerIdValue] = useState(useParams());
  const [task_data, SetTaskData] = useState([]);
  const [gst_percent, SetGstPercent] = useState("");

  useEffect(() => {
    console.log("ModalCreateRework close data :", close_data);
  }, []);

  useEffect(() => {
    if (props.isOpen) {
      console.log("ModalCreateRework On Open :", props);
      SetIsOpen(props.isOpen);
      get_init();
    }
  }, [props.isOpen]);

  const Switch = ({ isOn, handleToggle, onColor }) => {
    return (
      <>
        <input
          checked={isOn}
          onChange={handleToggle}
          className="react-switch-checkbox"
          id={`react-switch-new`}
          type="checkbox"
        />
        <label
          style={{ background: isOn && onColor }}
          className="react-switch-label"
          htmlFor={`react-switch-new`}
        >
          <span className={`react-switch-button`} />
        </label>
      </>
    );
  };

  async function get_init() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: id_value.order_id,
        service_id: props.data.service_id,
      },
    };
    let res = await api("/outlet/create_rework_init", pass_data);
    console.log("create_rework_init res :", res);
    if (res.response.hasOwnProperty("tasks")) {
      let task_value = res.response.tasks;
      task_value.map((ele) => {
        ele.checked = true;
        SetSaveData((prevValue) => {
          let add_data = {
            id: ele.id,
            salary: "",
          };
          prevValue.task.push(add_data);
          return { ...prevValue };
        });
      });
      SetTaskData(task_value);
      SetSaveData((prevValue) => {
        prevValue.service_id = props.data.service_id;
        return { ...prevValue };
      });
    }
    if (res.response.hasOwnProperty("settings")) {
      SetGstPercent(res.response.settings.gst_percent);
    }
  }

  function input_on_change(value: any, name: any) {
    SetSaveData((prevValue) => {
      prevValue[name] = value;
      return { ...prevValue };
    });
  }

  function free_on_change() {
    SetSaveData((prevValue) => {
      prevValue.free = !prevValue.free;
      return { ...prevValue };
    });
  }

  async function create_rework() {
    console.log("Create Rework Submit :", save_data);
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: id_value.order_id,
      },
      post: save_data,
    };
    let res = await api("/outlet/rework_service_v2", pass_data);
    console.log("rework_service_v2 res :", res);
    if (res.response.hasOwnProperty("order_services")) {
      let item = close_data;
      item.action = "save";
      item.service_data = res.response.order_services;
      SetCloseData(item);
      SetIsOpen(false);
      SetSaveData(initial_value);
      props.close(close_data);
    }
  }

  function onServiceChange(item: any, index: any) {
    SetTaskData((prevValue) => {
      prevValue[index].checked = !prevValue[index].checked;
      if (prevValue[index].checked) {
        SetSaveData((prevValue) => {
          let add_data = {
            id: item.id,
            salary: "",
          };
          prevValue.task.push(add_data);
          return { ...prevValue };
        });
      } else {
        SetSaveData((prevValue) => {
          let s_index = prevValue.task.findIndex(
            (s_value) => s_value.id == item.id
          );
          prevValue.task.splice(s_index, 1);
          return { ...prevValue };
        });
      }
      return [...prevValue];
    });
  }

  return (
    <div>
      <SlidingPane
        className="some-custom-class"
        overlayClassName="some-custom-overlay-class"
        isOpen={is_open}
        title="Create Rework"
        onRequestClose={() => {
          // triggered on "<" on left top click or on outside click
          console.log("close");
          let item = close_data;
          item.action = "close";
          SetCloseData(item);
          SetIsOpen(false);
          props.close(close_data);
        }}
        from="right"
        width="500px"
      >
        <div className="row px-2">
          <div className="ms-2 mt-3 form-check">
            <label className="form-check-label">
              <input
                className="form-check"
                type="checkbox"
                checked={save_data.free}
                id="flexCheck"
                onChange={(e) => {
                  free_on_change();
                }}
              />
              <p className="mb-0">Free</p>
            </label>
          </div>
          <div className="mt-3">
            <label className="form-label">Message</label>
            <textarea
              type="text"
              className="form-control"
              rows={2}
              value={save_data.message}
              onChange={(e) => {
                input_on_change(e.target.value, "message");
              }}
            ></textarea>
          </div>

          {!save_data.free ? (
            <div className="row">
              <div className="col-6 mt-3">
                <label className="form-label">GST</label>
                {/* <input
                  type="text"
                  className="form-control"
                  value={save_data.gst}
                  onChange={(e) => {
                    input_on_change(e.target.value, "gst");
                  }}
                /> */}
                <Switch
                  isOn={save_data.gst}
                  onColor="#06D6A0"
                  handleToggle={(e) => {
                    SetSaveData((prevValue) => {
                      prevValue.gst = !prevValue.gst;
                      // let entered_amount = e.target.value;
                      let gst_amount_value =
                        (gst_percent / 100) * prevValue.amount;
                      prevValue.gst_amount = gst_amount_value;

                      if (prevValue.gst) {
                        prevValue.total_amount =
                          parseFloat(gst_amount_value, 2) +
                          parseFloat(prevValue.amount, 2);
                      } else {
                        prevValue.total_amount = prevValue.amount;
                      }
                      return { ...prevValue };
                    });
                  }}
                />
              </div>

              <div className="col-6 mt-3">
                <label className="form-label">
                  Amount <span>- Without GST</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={save_data.amount}
                  onChange={(e) => {
                    // input_on_change(e.target.value, "amount");
                    SetSaveData((prevValue) => {
                      let entered_amount = e.target.value;
                      let gst_amount_value =
                        (gst_percent / 100) * entered_amount;
                      prevValue.amount = entered_amount;
                      prevValue.gst_amount = gst_amount_value;

                      if (prevValue.gst) {
                        prevValue.total_amount =
                          parseFloat(gst_amount_value, 2) +
                          parseFloat(entered_amount, 2);
                      } else {
                        prevValue.total_amount = entered_amount;
                      }
                      return { ...prevValue };
                    });
                  }}
                />
              </div>
              {/* Gst Amount */}
              {save_data.gst ? (
                <div className="col-6 mt-3">
                  <label className="form-label">GST Amount</label>
                  <input
                    type="text"
                    className="form-control"
                    disabled={true}
                    value={save_data.gst_amount}
                  />
                </div>
              ) : null}

              {/* Total Amount */}
              <div className="col-6 mt-3">
                <label className="form-label">Total Amount</label>
                <input
                  type="text"
                  className="form-control"
                  disabled={true}
                  value={save_data.total_amount}
                />
              </div>
            </div>
          ) : null}

          <div className="pt-3">
            <p>Task List </p>
            {task_data.map((ele, index) => (
              <div className="mb-2 form-check" key={index}>
                <div className="row align-items-center">
                  <div className="col-5">
                    <label className="form-check-label mb-0">
                      <input
                        className="form-check"
                        type="checkbox"
                        id="flexCheckDefault"
                        checked={ele.checked}
                        onChange={() => {
                          onServiceChange(ele, index);
                        }}
                      />
                      {ele.name}
                    </label>
                  </div>
                  {ele.checked ? (
                    <div className="col-7 p-0">
                      <label className="form-check-label mb-0">
                        <input
                          type="text"
                          name="role"
                          className="form-control"
                          placeholder="Editors Pay"
                          required
                          onChange={(e) => {
                            console.log("Price :", e.target.value);
                            SetSaveData((prevValue) => {
                              let s_index = prevValue.task.findIndex(
                                (s_value) => s_value.id == ele.id
                              );
                              console.log("s_index :", s_index);
                              prevValue.task[s_index].salary = e.target.value;
                              return { ...prevValue };
                            });
                          }}
                        />
                      </label>
                    </div>
                  ) : null}
                </div>
              </div>
            ))}
          </div>

          <div className="ms-auto">
            <button
              className="btn btn-light-outline btn-lg mt-3"
              onClick={() => {
                create_rework();
              }}
            >
              Create
            </button>
          </div>
        </div>
      </SlidingPane>
    </div>
  );
}
